<template>
  <div>
    <van-nav-bar :left-text="'您好，' + userInfo.emp_name" :right-text="currentDate" title="票据上传" />
    <van-panel v-if="uploadData.selectedClient" :title="uploadData.selectedClient.sname" :desc="uploadData.selectedClient.name" :status="uploadData.statusName" />
    <van-tabbar v-model="activeTabbar" safe-area-inset-bottom>
      <van-tabbar-item name="history" icon="home-o">历史上传记录</van-tabbar-item>
      <van-tabbar-item name="upload" icon="search">票据上传</van-tabbar-item>
    </van-tabbar>
    <div v-if="activeTabbar === 'history'">
      <van-row>
        <van-col :span="18"><base-date v-model="selectedDate" type="year-month" label="查询账期" @change="getElecnotes" /></van-col>
        <van-col :span="6" style="padding-top: 5px;"><base-button type="warning" @click="getElecnotes">刷新</base-button></van-col>
      </van-row>
      <van-row><van-col span="24" class="tip-msg">提示：点击上传记录，可查看上传文件明细！</van-col></van-row>
      <van-row class="list-title">
        <van-col span="8">上传时间</van-col>
        <van-col span="8">账期</van-col>
        <van-col span="8">批次</van-col>
      </van-row>
      <template v-if="elecnotesList && elecnotesList.length > 0">
        <van-cell
          v-for="elec in elecnotesList"
          :key="elec.id"
          class="list-tip"
          @click="
            onCollapseChange(elec);
            showDetails = true;
          "
        >
          <van-col span="8" style="text-align: center;">{{ elec.create_time }}</van-col>
          <van-col span="8" style="text-align: center;">{{ elec.curr_date }}</van-col>
          <van-col span="8" style="text-align: center;">{{ elec.batch }}</van-col>
        </van-cell>
      </template>
      <template v-else>
        <van-col span="24" class="list-tip">{{ tip }}</van-col>
      </template>
      <van-popup :style="{ height: '90%' }" v-model="showDetails" position="top" closeable>
        <br >
        <br >
        <van-tabs v-model="activeHistory">
          <van-tab v-for="step in steps" :key="step.id" :title="step.name">
            <van-col v-for="file in step.historyOtherList" :key="file.id" :span="24" style="text-align: left">
              <a :href="BACKEND_API + '/' + file.img_url + '?token=' + token" target="_blank">{{ file.fileName }}</a>
            </van-col>
            <van-col v-for="(image, index) in step.historyImageList" :key="image.id" :span="6" style="text-align: center">
              <van-image :src="BACKEND_API + '/' + image.img_url + '?token=' + token" width="80" height="80" @click="onPreview(index)" />
            </van-col>
          </van-tab>
        </van-tabs>
        <van-col :span="24" style="text-align: center"><base-button @click="showDetails = false">关闭</base-button></van-col>
      </van-popup>
      <van-image-preview v-model="showPreview" :images="imagesUrlList" :start-position="startPosition" :closeable="true" />
    </div>
    <div v-if="activeTabbar === 'upload'">
      <van-row><van-col span="24" class="err-msg" style="text-align: center;">注意：拍照时请确保图片拍摄清晰！</van-col></van-row>
      <van-progress v-if="uploading" :percentage="uploadingPercentage" :pivot-text="uploadingMsg" color="#13ce66" />
      <van-steps :active="3">
        <van-step>开始拍照</van-step>
        <van-step>等待上传</van-step>
        <van-step>上传完成</van-step>
      </van-steps>
      <van-tabs v-model="active">
        <van-tab v-for="step in steps" :key="step.id" :title="step.name">
          <div v-if="!step.hasError">
            <van-col :span="24" style="text-align: center;">
              <br >
              <van-uploader
                v-model="step.fileList"
                :max-count="99"
                :disabled="!canUpload"
                :deletable="canUpload"
                :after-read="afterRead"
                :before-delete="beforeDelete"
                accept="*"
                upload-text="请选择文件"
                multiple
              />
            </van-col>
          </div>
          <div v-else class="err-msg">{{ step.errorMsg }}</div>
        </van-tab>
      </van-tabs>
    </div>
    <init :init-states="initStates" @after-init="init" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getLastBatch, getElecnotesList, getElecnotesDetail, uploadElecnotes, deleteFile } from '@/api/elecnotes';
import { getServiceList } from '@/api/service';
import Init from '@/components/base/init';
export default {
  name: 'ElecnotesUpload',
  components: { Init },
  data() {
    return {
      showDatePicker: false,
      showDetails: false,
      showPreview: false,
      active: 0,
      activeHistory: 0,
      activeTabbar: 'upload',
      uploading: false,
      uploadingMsg: '',
      uploadingPercentage: 0,
      tip: this.CONST.EMPTY_MSG,
      canUpload: false,

      selectedDate: null,
      elecnotesList: [],
      imagesUrlList: [],
      startPosition: 0,

      fileOrd: 1,
      uploadData: {
        token: null,
        ele_id: null,
        selectedClient: null,
        client_id: null,
        batch: null,
        is_phone: true,
        curr_date: null,
        statusName: ''
      },
      steps: [
        {
          id: '1',
          name: '上月完税',
          fileList: [],
          historyOtherList: [],
          historyImageList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '2',
          name: '本月收入票',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '3',
          name: '银行收付',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '4',
          name: '成本费用票',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '5',
          name: '辅助资料',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        }
      ],
      initStates: [
        {
          key: 'app/initCurrentDate'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['token', 'userInfo', 'currentDate', 'selectedClient'])
  },
  methods: {
    init() {
      this.uploadData.token = this.token;
      this.uploadData.curr_date = this.currentDate;
      this.selectedDate = this.currentDate;
      if (this.selectedClient) {
        this.uploadData.selectedClient = this.selectedClient;
        this.uploadData.client_id = this.selectedClient.id;
        this.getLastBatchCode();
        getServiceList({
          client_id: this.uploadData.client_id,
          product_ids: '1',
          begin_end_date: this.uploadData.curr_date
        }).then(resp => {
          const rows = resp.rows || [];
          if (rows.length > 0) {
            this.uploadData.statusName = '服务中';
          } else {
            this.uploadData.statusName = '暂无服务';
          }
        });
        this.getElecnotes();
        this.canUpload = true;
      } else {
        this.error('请先选择客户，再操作票据上传');
      }
    },
    onPreview(index) {
      this.startPosition = index;
      this.showPreview = true;
    },
    onCollapseChange(elec) {
      getElecnotesDetail({
        id: elec.id
      }).then(resp => {
        this.steps.forEach(step => {
          step.historyOtherList = [];
          step.historyImageList = [];
        });
        this.imagesUrlList = [];
        const fileList = resp.rows || [];
        fileList.forEach(file => {
          const filePos = file.img_url.lastIndexOf('/');
          file.fileName = file.img_url.substring(filePos + 1);
          const suffixPos = file.img_url.lastIndexOf('.');
          const suffixName = file.img_url.substring(suffixPos + 1);
          file.isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null;
          let step = this.steps.find(step => step.id === file.type);
          if (!step) {
            step = this.steps[0];
          }
          if (file.isImg) {
            step.historyImageList.push(file);
            this.imagesUrlList.push(this.BACKEND_API + '/' + file.img_url + '?token=' + this.token);
          } else {
            step.historyOtherList.push(file);
          }
        });
      });
    },
    getLastBatchCode() {
      return new Promise((resolve, reject) => {
        this.uploadData.batch = this.Utils.df(null, '{m}{d}001');
        getLastBatch({
          client_id: parseInt(this.uploadData.client_id)
        })
          .then(resp => {
            const batch = resp.obj;
            if (this.Utils.df(null, '{m}{d}') === batch.substring(0, 4)) {
              const prefix = batch.substring(0, 4);
              const code = parseInt(batch.substring(4));
              this.uploadData.batch = prefix + this.Utils.prefixInteger(code + 1, 3);
            }
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getElecnotes() {
      this.tip = '查询中...';
      getElecnotesList({
        cx_user: this.CONST.CX_USER,
        create_id: this.userInfo.emp_id,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        client_id: this.uploadData.client_id,
        curr_date: this.selectedDate
      })
        .then(resp => {
          this.elecnotesList = resp.rows || [];
          if (this.elecnotesList.length === 0) {
            this.tip = this.CONST.EMPTY_MSG;
          }
        })
        .catch(() => {
          this.tip = this.CONST.EMPTY_MSG;
        });
    },
    beforeDelete(file) {
      return new Promise((resolve, reject) => {
        deleteFile({
          id: file.obj.id
        }).then(resp => {
          if (resp.success) {
            resolve();
            this.toast(resp.msg);
          } else {
            reject();
          }
        });
      });
    },
    async afterRead(file) {
      this.canUpload = false;
      this.uploading = true;
      this.uploadingPercentage = 0;
      let files = [];
      if (file instanceof Array) {
        files = file;
      } else {
        files.push(file);
      }
      for (let i = 0; i < files.length; i++) {
        this.uploadingPercentage = parseFloat(parseFloat(((i + 1) / files.length) * 100).toFixed(2));
        this.uploadingMsg = ` ${i + 1}/${files.length}`;

        const originFile = files[i];
        const suffixPos = originFile.file.name.lastIndexOf('.');
        const suffixName = originFile.file.name.substring(suffixPos + 1);
        const isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null;
        if (isImg) {
          const rst = await this.lrz(originFile.file);
          await this.uploadFile(originFile, rst.formData, this.fileOrd++).catch(() => {
            this.error('文件上传失败');
          });
        } else {
          const formData = new FormData();
          formData.append('file', originFile.file);
          await this.uploadFile(originFile, formData, this.fileOrd++).catch(() => {
            this.error('文件上传失败');
          });
        }
      }
      this.canUpload = true;
      this.uploading = false;
      this.uploadingPercentage = 100;
    },
    uploadFile(originFile, formData, ord) {
      return new Promise((resolve, reject) => {
        for (const key in this.uploadData) {
          formData.append(key, this.uploadData[key]);
        }
        formData.append('type', this.steps[this.active].id);
        uploadElecnotes(formData)
          .then(resp => {
            if (resp.success) {
              if (resp.obj) {
                originFile.obj = resp.obj;
                this.uploadData.ele_id = resp.obj.ele_id;
              }
              console.log('文件上传成功 ord: ', ord);
              this.success(resp.msg);
              resolve();
            } else {
              console.error('文件上传失败 ord: ', ord);
              this.delFile(originFile);
              reject(resp.msg);
            }
          })
          .catch(error => {
            console.error('文件上传失败 ord: ', ord);
            this.delFile(originFile);
            reject(error.message);
          });
      });
    },
    delFile(step, file) {
      const index = step.fileList.indexOf(file);
      if (index !== -1) {
        step.fileList.splice(index, 1);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/elecnotes/upload-file.vue